import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import 'react-bootstrap-range-slider/dist/react-bootstrap-range-slider.css';

import LoginLanding from './base/LoginLanding';
import FilmApp from './film/FilmApp';
import MissionApp from './mission/MissionApp';
import FilmSlideshow from './film/FilmSlideshow';
import MissionSlideshow from './mission/MissionSlideshow';

const path = window.location.pathname;

let AppComponent;
if (path === '/ai-film-slideshow') {
  AppComponent = FilmSlideshow;
} else if (path === '/ai-mission-slideshow') {
  AppComponent = MissionSlideshow;
} else if (path.startsWith('/ai-mission')) {
  AppComponent = MissionApp;
} else if (path.startsWith('/ai-film')) {
  AppComponent = FilmApp;
} else if (path === '/portal') {
  AppComponent = LoginLanding;
} else if (path.startsWith('/manage-servers')) {
  const host = window.location.hostname;
  const port = window.location.port;
  if ((host === 'localhost' || host === '127.0.0.1') && (port === '3000' || port === '3001')) {
    const managePort = port === '3001' ? '3000' : '3001';
    window.location.href = `http://${host}:${managePort}${path}${window.location.search}`;
  }
} else {
  window.location.href = '/portal';
}

if (AppComponent) {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <AppComponent />
    </React.StrictMode>
  );
}

reportWebVitals();
